import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { parsePhoneNumber } from 'libphonenumber-js/max';

function formatMaskNumber(number) {
  if (!number) return '';

  return formatPhoneNumberIntl(number);
}

function filterBrPhone(phone) {
  if (phone) {
    if (phone.indexOf('+') !== -1) {
      return phone;
    }
    return `+55${phone}`;
  }
  return phone;
}

function validatePhone(phone, cctld) {
  let validNumber = false;
  try {
    if (!phone) return false;

    const phoneNumber = parsePhoneNumber(phone, cctld);

    if (!phoneNumber) {
      return false;
    }

    const isValidNumber = phoneNumber.isValid();

    validNumber = isValidNumber ? phoneNumber?.number : null;
  } catch (error) {
    console.log('validatePhone error:', { phone, cctld, error: error.message });
  }
  return validNumber;
}

export { filterBrPhone, validatePhone, formatMaskNumber };
